import { useAuth } from '@drycut/auth';
import { useScheduledRefresh } from '@drycut/controlled-components';
import { StylistBoard } from '@drycut/stylist-components';
import { useNavigate } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function Dashboard(): React.ReactNode {
  useDocumentTitle('DRYCUT - Stylist dashboard');

  const navigate = useNavigate();
  const { currentSlug } = useAuth();

  // Refresh the screen at midnight and noon to ensure that the content is always up to date.
  useScheduledRefresh([
    { hour: 20 }, // 8pm, to ensure that the schedule for the next day is always up to date
    { hour: 0 }, // midnight (for new deployments)
  ]);

  if (!currentSlug) {
    navigate('/not-found');
    return null;
  }

  return <StylistBoard slug={currentSlug} />;
}
